import { render, staticRenderFns } from "./MusicView.vue?vue&type=template&id=3870c742"
import script from "./MusicView.vue?vue&type=script&lang=js"
export * from "./MusicView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports